import React, { useEffect, useState } from 'react';
import css from './styles.module.css';

export default function TabsV2({ className, children, value, onChange }) {
  const [currentValue, setCurrentValue] = useState(value);

  useEffect(() => {
    setCurrentValue(value);
  }, [value]);

  const handleTabClick = value => {
    setCurrentValue(value);
    onChange && onChange(value);
  };

  return (
    <div>
      <div className={`${css.tabsWrapper} ${className}`}>
        {React.Children.map(children, (child, _) => {
          return React.cloneElement(child, {
            value: child.props.value,
            isActive: currentValue === child.props.value,
            onClick: () => handleTabClick(child.props.value),
          });
        })}
      </div>
    </div>
  );
}
